module.exports = __webpack_public_path__ + "435879eab358c89f0cbca8652c784cae.png";